// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__OfLX2","tabsBox":"styles_tabsBox__33cZO","createButton":"styles_createButton__2Bby7"};